import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import BlotFormatter from 'quill-blot-formatter';
import '../../../../node_modules/draft-js/dist/Draft.css';

// Crear un custom image blot que permita blob URLs
const BlockEmbed = Quill.import('blots/block/embed');

class ImageBlot extends BlockEmbed {
  static blotName = 'image';
  static tagName = 'img';

  static create(value) {
    let node = super.create();
    if (typeof value === 'string') {
      node.setAttribute('src', value);
    } else if (typeof value === 'object') {
      Object.keys(value).forEach(key => {
        node.setAttribute(key, value[key]);
      });
    }
    return node;
  }

  static value(node) {
    const attributes = {
      src: node.getAttribute('src'),
      alt: node.getAttribute('alt'),
      width: node.getAttribute('width'),
      height: node.getAttribute('height'),
      style: node.getAttribute('style'),
      'data-filename': node.getAttribute('data-filename')
    };
    
    Object.keys(attributes).forEach(key => {
      if (attributes[key] === null || attributes[key] === undefined) {
        delete attributes[key];
      }
    });
    
    return attributes;
  }

  static sanitize(url) {
    return url;
  }

  // Preservar atributos al renderizar
  static formats(node) {
    return {
      width: node.getAttribute('width'),
      height: node.getAttribute('height'),
      style: node.getAttribute('style'),
      'data-filename': node.getAttribute('data-filename')
    };
  }
}

Quill.register(ImageBlot);
Quill.register('modules/blotFormatter', BlotFormatter);

class EditorDeTextoCompleto extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      editorHtml: '',
      imagenesContenido: [],
      contenidoInicializado: false
    };
    this.quillRef = React.createRef();
  }


  componentDidMount() {
    if (this.quillRef.current) {
      //console.log("Contenido inicial recibido:", this.props.contenidoRecibido);
      const quill = this.quillRef.current.getEditor();
      const toolbar = quill.getModule('toolbar');
      toolbar.addHandler('image', this.imageHandler);
      quill.root.addEventListener('paste', this.handlePaste);
      
      const contenidoInicial = this.props.contenidoRecibido || '';
      this.setState({ editorHtml: contenidoInicial });
      
      setTimeout(() => {
        this.preservarAtributosImagenes();
      }, 100);
    }
  }

  componentWillUnmount() {
    if (this.quillRef.current) {
      const quill = this.quillRef.current.getEditor();
      quill.root.removeEventListener('paste', this.handlePaste);
    }
  }

  preservarAtributosImagenes = () => {
    if (!this.quillRef.current) return;
    
    const quill = this.quillRef.current.getEditor();
    const imagenes = quill.root.querySelectorAll('img');
    
    imagenes.forEach(img => {
      const width = img.getAttribute('width');
      const height = img.getAttribute('height');
      const style = img.getAttribute('style');
      
      if (width || height || style) {
        //console.log('Preservando atributos de imagen:', { width, height, style });
        
        if (width) img.setAttribute('width', width);
        if (height) img.setAttribute('height', height);
        if (style) img.setAttribute('style', style);
      }
    });
  }

  imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();
    
    input.onchange = () => {
      const file = input.files[0];
      if (file) {
        this.insertarImagen(file);
      }
    };
  }

  handlePaste = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    const items = clipboardData.items;
    
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf('image') !== -1) {
        e.preventDefault();
        const blob = item.getAsFile();
        this.insertarImagen(blob);
        break;
      }
    }
  }

  insertarImagen = (file) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const f = new Date();
      const dia = ('0' + f.getDate()).slice(-2);
      const mes = ('0' + (f.getMonth() + 1)).slice(-2);
      const año = f.getFullYear();
      const hora = ('0' + f.getHours()).slice(-2);
      const minutos = ('0' + f.getMinutes()).slice(-2);
      const segundos = ('0' + f.getSeconds()).slice(-2);
      const nombreImagen = `${dia}${mes}${año}${hora}${minutos}${segundos}_editor_img`;
      
      if (this.quillRef.current) {
        const quill = this.quillRef.current.getEditor();
        const range = quill.getSelection(true);
        
        quill.insertEmbed(range.index, 'image', {
          src: e.target.result,
          'data-filename': nombreImagen,
          alt: nombreImagen
        });
        
        quill.setSelection(range.index + 1);
      }
    };
    
    reader.readAsDataURL(file);
  }
  
  handleChange = (html) => {
    this.setState({ editorHtml: html });
    
    setTimeout(() => {
      this.preservarAtributosImagenes();
    }, 10);
    
    if (this.props.onContentChange) {
      this.props.onContentChange(html);
    }
  };
  
  render() {
    return (
      <ReactQuill
        ref={this.quillRef}
        theme="snow"
        onChange={this.handleChange}
        value={this.state.editorHtml}
        modules={EditorDeTextoCompleto.modules}
        formats={EditorDeTextoCompleto.formats}
        bounds={'#root'}
        placeholder={this.props.placeholder || "Escribe tu contenido aquí..."}
        style={{ height: '35vh', minWidth: '600px' }}
      />
    );
  }
}

EditorDeTextoCompleto.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' }
    ],
    ['link', 'image', 'video'],
    ['clean']
  ],
  blotFormatter: {
    overlay: {
      className: 'blot-formatter__overlay',
      style: {
        position: 'absolute',
        boxSizing: 'border-box',
        border: '1px dashed #444',
      }
    },
    resize: {
      allowResizing: true,
    },
    align: {
      alignments: ['left', 'center', 'right'],
      toolbar: {
        allowAligning: true,
        allowClear: true,
      }
    }
  }
};

/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
EditorDeTextoCompleto.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
  'width',
  'height',
  'style'
];
export default EditorDeTextoCompleto;